import type { TracePayload } from "Types/feTracingApi";
import { STORE_KEY_AUTH, sessionStoreGet } from "mailup-react-helpers";

export const feTracingApiTraceMessage = async (
  payload: TracePayload,
): Promise<void> => {
  try {
    await fetch(`${process.env.FETRACING_URL as unknown as string}/api/trace`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStoreGet(STORE_KEY_AUTH) as string}`,
      },
      body: JSON.stringify(payload),
    });
  } catch (error) {
    if (
      error instanceof TypeError &&
      error.message.toLowerCase().includes("failed to fetch")
    ) {
      return;
    }

    throw error;
  }
};
